export enum ErrorType {
  VariantSelectionMissing = 'VariantSelectionMissing',
  HoodieSizeMissing = 'HoodieSizeMissing',
}

export type VariantSelectionError = {
  productID: string;
  error: ErrorType;
};
